import {useState, useEffect} from 'react';
import {tasveerStorage} from '../firebase/config';

const useStorage = (file, genre) => {
    const [progress, setProgress] = useState(0);
    const [error, setError] = useState(null);
    const [url, setUrl] = useState(null);

    useEffect(() => {
        const storageRef = tasveerStorage.ref().child('images/'+file.name);
        // const storeRef = tasveerStore.collection("photos");
        

        storageRef.put(file).on('state_changed', (snap) => {
            let percent = (snap.bytesTransferred / snap.totalBytes) * 100;
            setProgress(percent);
        }, (err) => {
            setError(err);
        }, async () => {
            const url = await storageRef.getDownloadURL();
            // const createdAt = timestamp();
            // storeRef.add({name:file.name , url, genre, createdAt});
            setUrl(url);
        })
    }, [file, genre]);

    return { url, progress, error };

}


export default useStorage;